function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    focused,
    hideRequirements,
    isCompact
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    var isHc = theme.mode === 'contrast';
    return {
      container: _objectSpread({
        boxSizing: 'border-box',
        position: 'relative',
        width: '100%',
        'div.vn-input': _objectSpread(_objectSpread({
          '.vn-trailing_button': {
            marginRight: "calc(".concat(theme.layout.size2, " - 1px)")
          }
        }, isCompact && _objectSpread(_objectSpread({}, focused && !hideRequirements && _objectSpread({}, isHc && {
          borderColor: theme.palette.primary.active
        })), {}, {
          '> .vn-trailing_button': {
            width: '28px',
            '> svg': {
              padding: 0
            }
          }
        })), {}, {
          '&.focused': {
            '.vn-trailing_button': {
              marginRight: "calc(".concat(theme.layout.size2, " - 2px)")
            }
          }
        })
      }, highContrastMediaQuery(theme)),
      requirementsContainer: _objectSpread({
        backgroundColor: theme.palette.background.container,
        borderColor: 'transparent',
        borderStyle: 'solid',
        boxSizing: 'border-box',
        fontFamily: theme.typography.family0,
        zIndex: theme.elevation.popover,
        borderRadius: theme.borderRadius3,
        '&::before': {
          backgroundColor: 'transparent',
          boxShadow: theme.level.level16,
          borderRadius: theme.borderRadius3,
          content: "' '",
          height: '100%',
          pointerEvents: 'none',
          position: 'absolute',
          width: '100%'
        }
      }, isHc && {
        borderWidth: '2px',
        borderColor: theme.palette.primary.active
      })
    };
  }, [focused, hideRequirements, isCompact, theme]);
};
export default useStyles;